import { render, staticRenderFns } from "./lecture-main.vue?vue&type=template&id=5fe93aaa&scoped=true"
import script from "./lecture-main.vue?vue&type=script&lang=js"
export * from "./lecture-main.vue?vue&type=script&lang=js"
import style0 from "./lecture-main.vue?vue&type=style&index=0&id=5fe93aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe93aaa",
  null
  
)

export default component.exports